module.exports = __webpack_public_path__ + "frontend/static/media/Men accessories.032d2aaf.png";